// app/javascript/controllers/device_registration_controller.js
import { Controller } from "@hotwired/stimulus"

function generateUUID() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}

export default class extends Controller {
  static targets = ["token"]

  connect() {
    let token = localStorage.getItem("device_token")
    if (!token) {
      token = generateUUID()
      localStorage.setItem("device_token", token)
    }
    this.tokenTarget.value = token
  }
}
